import {Create, useNotify, useRedirect} from "react-admin";
import {QuizAssessmentAvailabilityForm} from "./component/quiz-assessment-availability.form";
import {CancelToolbar} from "../../components/core/core-cancel.action.component";

export function QuizAssessmentAvailabilityCreate(props) {
  const redirect = useRedirect()
  const notify = useNotify()

  const onSuccess = ({ data }) => {
    notify('Avaliação criada com sucesso')
    redirect(`/quiz-assessment-availability/results/${data.id}`)
  }

  return (
    <>
      <Create
        {...props}
        onSuccess={onSuccess}
        actions={
          <CancelToolbar />
        }
      >
        <QuizAssessmentAvailabilityForm disableFields={['disabled']} />
      </Create>
    </>
  )
}
